import React from "react";
import { Link } from "gatsby";

import globeIcon from "../../img/icons8-global-100.png";
import graphIcon from "../../img/icons8-graph-100.png";
import badgeIcon from "../../img/icons8-verification-100.png";
import campaignIcon from "../../img/icons8-campaigns-64.png";

const iconMap = {
  globe: globeIcon,
  graph: graphIcon,
  badge: badgeIcon,
  campaign: campaignIcon,
};

const PillarsBlock = ({
  title,
  intro,
  pillars = [],
  stats = [],
  ctaText,
  ctaLink,
}) => {
  return (
    <section id="our-mission" className="bg-white pb-lg-5">
      <div className="container-fluid">
        <div className="row justify-content-center contained-xl mb-4">
          <div className="col-12 col-md-6 col-lg-5">
            {title && (
              <h2 className="mb-4 font-weight-bold">
                {title}
              </h2>
            )}

            {intro && <h3 className="font-weight-bold h5 mb-4">{intro}</h3>}
            {intro && <p className="mb-4">{intro}</p>}

            <div className="row">
              {pillars.map((pillar) => (
                <div
                  className="col-md-4 col-lg-4 mb-4 mb-lg-0"
                  key={pillar.title}
                >
                  <h4 className="h5 font-weight-bold text-uppercase">
                    {pillar.title}
                  </h4>
                  <p className="mb-0">{pillar.text}</p>
                </div>
              ))}
            </div>

            {ctaLink && (
              <div className="py-4">
                <Link to={ctaLink} className="h5 font-weight-normal text-info">
                  {ctaText}
                </Link>
              </div>
            )}
          </div>
            
          <div className="col-12 col-md-4 col-lg-5 mb-4 align-self-center">
             <div class="row">
            {stats.map((stat, idx) => {
              const IconSrc = iconMap[stat.icon];
              const isOdd = idx % 2 === 1;

              return (
               
                <div
                  key={stat.label}
                  className={`col col-md-6 px-lg-0 mb-4 d-flex align-items-center       
        `}
                >
                  {IconSrc && (
                    <img
                      src={IconSrc}
                      alt={stat.label}
                      className={"mr-3"}
                      style={{ width: "60px", height: "60px" }}
                    />
                  )}
                  <div>
                    <strong>{stat.label}</strong>
                  </div>
                  
                </div>
              );
            })}
          </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default PillarsBlock;
